import { render, staticRenderFns } from "./delPop.vue?vue&type=template&id=761aab51&"
import script from "./delPop.vue?vue&type=script&lang=js&"
export * from "./delPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports